import { CaretDoubleRightIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const ArrowDup = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <CaretDoubleRightIcon {...rest} size={Sizes[size]} color={fill} />;
};

ArrowDup.displayName = 'ArrowDup';
